import React from 'react';
import PropTypes from 'prop-types';
import locale from '@glu/locale';
import { withStyles } from '@glu/theming';
import { XCircleNextIcon } from '@glu/icons-react';

import styles from './Header.styles';

const Header = ({ classes, close }) => (
  <div className={`${classes.root} branding-header`}>
    <p>{locale.get('branding.createTheme')}</p>
    <button type="button" className={classes.close} onClick={close}>
      <XCircleNextIcon />
    </button>
  </div>
);

Header.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  close: PropTypes.func.isRequired
};

export default withStyles(styles)(Header);
